import CryptoJS from 'crypto-js';
import { getDecryptString, getEncryptString } from './crypto';

export default class AsyncLocalStorage {
  /**
   *
   * @param key
   * @returns
   */
  public static  getItem(key: string): any {


    const item = localStorage.getItem(key);

    try{
      if(item){
        let jsonstring = getDecryptString(item);
      
        let obj = JSON.parse(jsonstring);
  
        return obj;
  
      }else{
        return null;
      }
    }catch(err){
      console.log(err);
      return null;
    }
    


  }

  /**
   *
   * @param key
   * @param value
   */
  public static  setItem(key: string, value: string): any {
    const item = getEncryptString(value);
    
    localStorage.setItem(key, item);
  }

  /**
   *
   * @param key
   */
  public static removeItem(key: string): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      localStorage.removeItem(key);
      resolve(true);
    });
  }

  /**
   *
   * @param keys
   */
  public static removeItems(keys: string[]): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      for (const key of keys) localStorage.removeItem(key);
      resolve(true);
    });
  }
}
